import type { Experience } from '@experience/exp-card/dist/types/experience';
import type { SelectionType } from '@/entities/expSelection/model/expSelection.ts';

export const mapExperienceDataToSogu = (exp: Experience) => ({
  city_id: exp?.geo?.city?.[0]?.id,
  city_name: exp?.geo?.city?.[0]?.name,
  country_id: exp?.geo?.country?.[0]?.id,
  country_name: exp?.geo?.country?.[0]?.name,
  discount_rate: exp?.price?.discount?.value || 0,
  duration: exp?.duration,
  experience_id: exp?.id,
  format: exp?.format,
  full_price: exp?.price?.value,
  guide_id: exp?.guide?.id,
  instant_booking: exp?.is_instant_booking || false,
  rating: exp?.rating,
  title: exp?.title,
  is_paid: exp?.is_paid,
  is_paid_control: exp?.is_paid,
  status: exp?.status,
  type: exp?.type as SelectionType,
});
